import { useQuery } from "@tanstack/react-query";
import type { CapabilitiesAggregate } from "@eduviaos/shared";
import { api } from "@/lib/api";

/**
 * TanStack Query wrapper around `GET /api/me/capabilities` per TRD-17
 * §17.16.1. Cached for 5 minutes (matches BE Redis L2 TTL); a WebSocket
 * `capability.updated` event will invalidate the cache in Phase 0c.
 */
export function useCapabilities() {
  return useQuery<CapabilitiesAggregate>({
    queryKey: ["capabilities", "me"],
    queryFn: async () => api.get<CapabilitiesAggregate>("/me/capabilities"),
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });
}
